/*
 *   File : service.js
 *   Author URI : https://evoqins.com
 *   Description : Global function for API
 *   Integrations : axios
 *   Version : v1.1
*/

import axios from "axios";
// import { logOut } from "../Helper";
import Store from "../Store/store";
import Cookies from "js-cookie";
import { googleLogout } from "@react-oauth/google";
import { _clearLocalStorage } from "../Helper";

export default async function APIService(is_post, url, data, token = null, api_version = 1) {


    let API_URL = api_version === 3 ? process.env.REACT_APP_API_URL_V3 + url : api_version === 2 ? process.env.REACT_APP_API_URL_V2 + url : process.env.REACT_APP_API_URL + url;

    let auth_token = null;

    if (token === null) {
        auth_token = Store.getState().Reducer.ACCESS_TOKEN || sessionStorage.getItem('access_token');;
    } else {
        auth_token = token;
    }

    try {
        if (is_post === true) {
            return await axios
                .post(API_URL, data, {
                    headers: {
                        method: "post",
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth_token}`,
                    },
                })
                .then(function (response) {
                    return response.data;
                })
                .catch((error) => {
                    if (error.response.data.status_code === 401) {
                        _logout();
                        return error.response.data;
                    } else {
                        return error.response.data;
                    }
                });
        } else {
            return await axios
                .get(API_URL, {
                    headers: {
                        method: "get",
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth_token}`,
                    },
                })
                .then(function (response) {
                    return response.data;
                })
                .catch((error) => {
                    if (error.response.data.status_code === 401) {
                        _logout();
                        return error.response.data;
                    } else {
                        return error.response.data;
                    }
                });
        }
    } catch (error) {
        return {
            "status": false,
            "message": "Unable to process your request now",
            "status_code": 500
        };
    }
}

const _logout = () => {

    sessionStorage.removeItem('access_token');
    Cookies.remove("refresh_token", { path: '/', domain: process.env.REACT_APP_DOMAIN });
    _clearLocalStorage();

    Store.dispatch({
        type: 'UPDATE_ACCESS_TOKEN',
        payload: null,
    });
    Store.dispatch({
        type: 'UPDATE_REFRESH_TOKEN',
        payload: null,
    });

    Store.dispatch({
        type: 'UPDATE_USER_DATA',
        data: null
    });

    Store.dispatch({
        type: 'UPDATE_ACCOUNT_OPENING_MODAL_STATUS',
        payload: false,
    });

    googleLogout();
}